/**
 * Миксин для обработки валидации котировок
 */
export const quotationValidationMixin = {
  methods: {
    /**
     * Обработка ошибок валидации
     */
    handleValidationErrors(validationData) {
      let errorMessage = validationData.message || 'Ошибка валидации';
      
      // Если есть детальная информация об ошибках
      if (validationData.errors && validationData.errors.length > 0) {
        const errors = validationData.errors;
        
        errors.forEach(error => {
          if (error.type === 'missing_quotations' && error.services) {
            const serviceNames = error.services.map(service => service.service_name).join(', ');
            errorMessage = `Не заполнены запросы на котировку для услуг: ${serviceNames}. Заполните запросы на котировку по каждой услуге или удалите лишние услуги.`;
          } else if (error.type === 'missing_logistics_quotation' && error.services) {
            const serviceNames = error.services.map(service => service.service_name).join(', ');
            errorMessage = `Не заполнен запрос на котировку для логистики: ${serviceNames}. Заполните запрос на котировку по логистике для перевода заказа в статус "Получение котировки".`;
          } else if (error.type === 'incomplete_logistics_quotation' && error.services) {
            const serviceNames = error.services.map(service => service.service_name).join(', ');
            errorMessage = `Не полностью заполнен запрос на котировку для логистики: ${serviceNames}. Заполните запрос на котировку по логистике до конца для перевода заказа в статус "Получение котировки".`;
          }
        });
      }

      // Показываем уведомление с ошибкой
      this.$bvToast.toast(errorMessage, {
        title: 'Ошибка валидации',
        variant: 'warning',
        solid: true,
        noAutoHide: true,
        appendToast: true
      });

      // Также показываем модальное окно с детальной информацией
      this.showValidationModal(validationData);
    },

    /**
     * Показать модальное окно с детальной информацией об ошибках
     */
    showValidationModal(validationData) {
      // Создаем HTML-контент для модального окна
      const modalContent = this.createValidationModalContent(validationData);

      // Используем SweetAlert2 для отображения HTML
      this.$swal({
        title: 'Ошибка валидации',
        html: modalContent,
        icon: 'warning',
        confirmButtonText: 'Понятно',
        confirmButtonColor: '#ffc107',
        width: '600px'
      });
    },

    /**
     * Создать HTML-контент для модального окна валидации
     */
    createValidationModalContent(validationData) {
      let content = '<div class="text-left">';
      
      // Основное сообщение
      content += '<div class="mb-3">';
      content += '<h6 class="text-danger mb-2"><i class="fas fa-exclamation-triangle mr-2"></i>Детали ошибки:</h6>';
      content += '<p class="mb-0">' + (validationData.message || 'Неизвестная ошибка') + '</p>';
      content += '</div>';
      
      // Детали ошибок валидации
      if (validationData.errors && validationData.errors.length > 0) {
        validationData.errors.forEach(error => {
          if (error.type === 'missing_quotations' && error.services) {
            content += '<div class="mt-3">';
            content += '<h6 class="mb-2"><i class="fas fa-list mr-2"></i>Услуги без запросов на котировку:</h6>';
            content += '<ul class="list-unstyled">';
            error.services.forEach(service => {
              content += `<li class="mb-1"><i class="fas fa-times-circle text-danger mr-2"></i><strong>${service.service_name}</strong></li>`;
            });
            content += '</ul>';
            content += '</div>';
          } else if (error.type === 'missing_logistics_quotation' && error.services) {
            content += '<div class="mt-3">';
            content += '<h6 class="mb-2"><i class="fas fa-list mr-2"></i>Услуги без запросов на котировку:</h6>';
            content += '<ul class="list-unstyled">';
            error.services.forEach(service => {
              content += `<li class="mb-1"><i class="fas fa-times-circle text-danger mr-2"></i><strong>${service.service_name}</strong></li>`;
            });
            content += '</ul>';
            content += '</div>';
          } else if (error.type === 'incomplete_logistics_quotation' && error.services) {
            content += '<div class="mt-3">';
            content += '<h6 class="mb-2"><i class="fas fa-list mr-2"></i>Услуги без запросов на котировку:</h6>';
            content += '<ul class="list-unstyled">';
            error.services.forEach(service => {
              content += `<li class="mb-1"><i class="fas fa-exclamation-triangle text-warning mr-2"></i><strong>${service.service_name}</strong></li>`;
            });
            content += '</ul>';
            content += '</div>';
          } else if (error.type === 'no_quotation_answers' && error.services) {
            content += '<div class="mt-3">';
            content += '<h6 class="mb-2"><i class="fas fa-list mr-2"></i>Услуги без ответов на котировку:</h6>';
            content += '<ul class="list-unstyled">';
            error.services.forEach(service => {
              content += `<li class="mb-1"><i class="fas fa-times-circle text-danger mr-2"></i><strong>${service.service_name}</strong></li>`;
            });
            content += '</ul>';
            content += '</div>';
          } else if (error.type === 'filling_quotation_answers' && error.services) {
            content += '<div class="mt-3">';
            content += '<h6 class="mb-2"><i class="fas fa-list mr-2"></i>Услуги с необработанными ответами:</h6>';
            content += '<ul class="list-unstyled">';
            error.services.forEach(service => {
              content += `<li class="mb-1"><i class="fas fa-exclamation-triangle text-warning mr-2"></i><strong>${service.service_name}</strong></li>`;
            });
            content += '</ul>';
            content += '</div>';
          }
        });
      }
      
      // Инструкции для пользователя
      content += '<div class="mt-4 p-3 bg-light rounded">';
      content += '<h6 class="mb-2"><i class="fas fa-info-circle mr-2"></i>Что делать:</h6>';
      content += '<ul class="list-unstyled mb-0">';
      
      // Определяем тип ошибки для показа соответствующих инструкций
      let hasMissingQuotations = false;
      let hasLogisticsError = false;
      let hasNoQuotationAnswers = false;
      let hasFillQuotationAnswers = false;
      
      if (validationData.errors && validationData.errors.length > 0) {
        validationData.errors.forEach(error => {
          if (error.type === 'missing_quotations') {
            hasMissingQuotations = true;
          } else if (error.type === 'missing_logistics_quotation' || error.type === 'incomplete_logistics_quotation') {
            hasLogisticsError = true;
          } else if (error.type === 'no_quotation_answers') {
            hasNoQuotationAnswers = true;
          } else if (error.type === 'filling_quotation_answers') {
            hasFillQuotationAnswers = true;
          }
        });
      }
      
      if (hasMissingQuotations) {
        content += '<li class="mb-1"><i class="fas fa-check-circle text-success mr-2"></i>Заполните запросы на котировку для всех услуг</li>';
        content += '<li class="mb-1"><i class="fas fa-check-circle text-success mr-2"></i>Или удалите ненужные услуги из заказа</li>';
      }
      
      if (hasLogisticsError) {
        content += '<li class="mb-1"><i class="fas fa-check-circle text-success mr-2"></i>Завершите заполнение котировки по логистике</li>';
        content += '<li class="mb-1"><i class="fas fa-check-circle text-success mr-2"></i>Убедитесь, что все обязательные поля заполнены</li>';
      }
      
      if (hasNoQuotationAnswers) {
        content += '<li class="mb-1"><i class="fas fa-check-circle text-success mr-2"></i>Дождитесь получения ответов на котировку</li>';
        content += '<li class="mb-1"><i class="fas fa-check-circle text-success mr-2"></i>Или обратитесь к менеджеру для ускорения процесса</li>';
      }
      
      if (hasFillQuotationAnswers) {
        content += '<li class="mb-1"><i class="fas fa-check-circle text-success mr-2"></i>Дождаться, когда наши логисты дадут ответы по котировке</li>';
      }
      
      content += '</ul>';
      content += '</div>';
      
      content += '</div>';
      
      return content;
    },

    /**
     * Обработка ответа API с валидацией
     */
    handleApiResponseWithValidation(data, isSaveWithStatusChange = false) {
      // Проверяем валидацию в успешном ответе
      if (data.validation && !data.validation.success) {
        this.handleValidationErrors(data.validation);
        // Показываем сообщение о том, что данные сохранены, но статус не изменен
        this.$bvToast.toast('Данные сохранены, но статус не изменен из-за ошибок валидации', {
          title: 'Внимание',
          variant: 'warning',
          solid: true,
        });
        return false; // Возвращаем false чтобы показать что валидация не прошла
      }

      return true; // Возвращаем true если валидация прошла успешно
    }
  }
};
